function removeCountryLinksHref() {
  console.log("[GeoSelector] Starting removeCountryLinksHref function");

  // Sélectionner le conteneur
  const container = document.querySelector("#orbeFooterCountryList");
  console.log("[GeoSelector] Container found:", container);

  // Vérifier si le conteneur existe
  if (container) {
    // Sélectionner tous les liens existants et supprimer leurs href
    const links = container.querySelectorAll(
      ".md-form__select__country__list-link"
    );
    console.log("[GeoSelector] Initial links found:", links.length);

    links.forEach((link) => {
      console.log("[GeoSelector] Removing href from link:", link);
      link.removeAttribute("href");
    });

    // Observer les changements dans le DOM
    const observer = new MutationObserver((mutations) => {
      console.log(
        "[GeoSelector] Mutation detected:",
        mutations.length,
        "changes"
      );
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // Vérifier si le nouveau nœud est un élément et a la classe recherchée
          if (
            node.nodeType === 1 &&
            node.classList?.contains("md-form__select__country__list-link")
          ) {
            console.log(
              "[GeoSelector] New link node found, removing href:",
              node
            );
            node.removeAttribute("href");
          }
        });
      });
    });

    // Configuration de l'observer
    const config = {
      childList: true, // Observer l'ajout/suppression d'enfants
      subtree: true, // Observer les modifications dans l'arbre DOM complet
    };

    // Démarrer l'observation
    observer.observe(container, config);
    console.log("[GeoSelector] Observer started");
  } else {
    console.log("[GeoSelector] Container not found");
  }
}

// Exécuter la fonction quand le DOM est chargé
document.addEventListener("DOMContentLoaded", () => {
  console.log("[GeoSelector] DOM loaded, executing removeCountryLinksHref");
  removeCountryLinksHref();
});
